module.exports = __webpack_public_path__ + "img/t6-gray.8e611e51.png";